import React, { Component } from 'react';
import YantraDetailForm from './YantraDetailForm';
import NavBar from '../NavBar/NavBar';
import './YantraDetail.css';


class YantraDetail extends Component {
  render () {
    return (
      <div className="YantraDetail">
        <NavBar />
        <YantraDetailForm yantraResult={this.props.location.state.data} 
                          day={this.props.location.state.day}
                          month={this.props.location.state.month}
                          year={this.props.location.state.year}
                          />
      </div>
    )
  }
}

export default YantraDetail;



// WEBPACK FOOTER //
// ./src/components/YantraDetail/YantraDetail.js